import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  timelineAccordionStatus: {}
};

export const timelineAccordionStatusSlice = createSlice({
  name: 'timelineAccordionStatus',
  initialState,
  reducers: {
    setTimelineAccordionStatusSlice: (state, action: PayloadAction<any>) => {
      state.timelineAccordionStatus = action.payload;
    }
  }
});

export const { setTimelineAccordionStatusSlice } = timelineAccordionStatusSlice.actions;

export default timelineAccordionStatusSlice.reducer;
